module.exports = __webpack_public_path__ + "assets/security-blue.09bba0b2.svg";